(function () {
  function init(root) {
    if (root.dataset.yvReady === 'true') return;
    root.dataset.yvReady = 'true';

    var slides = Array.from(root.querySelectorAll('[data-yv-slide]'));
    var thumbs = Array.from(root.querySelectorAll('[data-yv-thumb]'));
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = Number(thumb.dataset.yvThumb);
        slides.forEach(function (slide, n) { slide.classList.toggle('is-active', n === index); });
        thumbs.forEach(function (item, n) {
          item.classList.toggle('is-active', n === index);
          item.setAttribute('aria-pressed', n === index ? 'true' : 'false');
        });
      });
    });

    var form = root.querySelector('[data-yv-form]');
    if (form) {
      var planInput = form.querySelector('[data-yv-plan-input]');
      var options = Array.from(form.querySelectorAll('[data-yv-offer]'));
      function syncOffer() {
        var selected = form.querySelector('input[name="yula_purchase"]:checked');
        options.forEach(function (option) { option.classList.toggle('is-selected', option.contains(selected)); });
        if (planInput) {
          planInput.value = selected ? selected.dataset.planId : '';
          planInput.disabled = !planInput.value;
        }
      }
      form.addEventListener('change', syncOffer);
      syncOffer();

    }

    var tabs = Array.from(root.querySelectorAll('.yv-tabs [role="tab"]'));
    var panels = Array.from(root.querySelectorAll('.yv-panel'));
    function activateTab(index) {
      tabs.forEach(function (tab, n) {
        var active = n === index;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
        panels[n].hidden = !active;
      });
      tabs[index].focus();
    }
    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () { activateTab(index); });
      tab.addEventListener('keydown', function (event) {
        var next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        activateTab(next);
      });
    });

    var voicesCarousel = root.querySelector('[data-yv-voices-carousel]');
    if (voicesCarousel) {
      var voicesTrack = voicesCarousel.querySelector('.yv-voices__grid');
      var voicesItems = Array.from(voicesTrack.querySelectorAll('article'));
      var voicesPrev = voicesCarousel.querySelector('[data-yv-voices-prev]');
      var voicesNext = voicesCarousel.querySelector('[data-yv-voices-next]');
      var voicesCurrent = voicesCarousel.querySelector('[data-yv-voices-current]');
      var voicesTotal = voicesCarousel.querySelector('[data-yv-voices-total]');
      var voicesPage = 0;
      var voicesDesktop = window.matchMedia('(min-width: 901px)');

      function updateVoicesCarousel() {
        if (!voicesDesktop.matches) {
          voicesPage = 0;
          voicesTrack.style.transform = '';
          return;
        }
        var perPage = 3;
        var totalPages = Math.max(1, Math.ceil(voicesItems.length / perPage));
        voicesPage = Math.min(voicesPage, totalPages - 1);
        var target = voicesItems[voicesPage * perPage];
        voicesTrack.style.transform = 'translate3d(-' + (target ? target.offsetLeft : 0) + 'px,0,0)';
        voicesPrev.disabled = voicesPage === 0;
        voicesNext.disabled = voicesPage === totalPages - 1;
        voicesCurrent.textContent = String(voicesPage + 1);
        voicesTotal.textContent = String(totalPages);
      }

      voicesPrev.addEventListener('click', function () {
        if (voicesPage > 0) {
          voicesPage -= 1;
          updateVoicesCarousel();
        }
      });
      voicesNext.addEventListener('click', function () {
        var totalPages = Math.max(1, Math.ceil(voicesItems.length / 3));
        if (voicesPage < totalPages - 1) {
          voicesPage += 1;
          updateVoicesCarousel();
        }
      });
      window.addEventListener('resize', updateVoicesCarousel);
      updateVoicesCarousel();
    }

    root.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var target = document.getElementById(link.hash.slice(1));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        history.pushState(null, '', link.hash);
      });
    });
  }

  function initAll() { document.querySelectorAll('[data-yula-v2]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
